import { UnleashClient } from '@unleash/proxy-client-react';

export const unleashClient = new UnleashClient({
  url: import.meta.env.VITE_UNLEASH_PROXY_URL ?? 'http://localhost:4242/proxy',
  clientKey:
    import.meta.env.VITE_UNLEASH_CLIENT_KEY ??
    'default:development.unleash-insecure-api-token',
  appName: import.meta.env.VITE_APP_NAME ?? 'saas-boilerplate',
});

export { useFlag } from '@unleash/proxy-client-react';

/**
 * Call after sign-in to set user context and start the Unleash client.
 * Pass subscriptionPlan to enable plan-based flag targeting.
 */
export function startFlagsForUser(
  userId: string,
  subscriptionPlan?: string,
): void {
  unleashClient.setContextField('userId', userId);
  if (subscriptionPlan) {
    unleashClient.setContextField('properties.subscriptionPlan', subscriptionPlan);
  }
  unleashClient.start();
}

/**
 * Call on sign-out to reset the Unleash context and stop the client.
 */
export function stopFlags(): void {
  unleashClient.stop();
}
